import { useStyletron } from "baseui";
import { BacnetServicesSupported } from "./types";
import { ListItem, ListItemLabel } from "baseui/list";
import { ParagraphMedium, ParagraphXSmall } from "baseui/typography";

const BacnetServicesSupportedList = (props: { servicesSupported: any }) => {
    const [css] = useStyletron();
    const servicesSupportedArray: boolean[] = props.servicesSupported && props.servicesSupported !== "" ? JSON.parse(props.servicesSupported) : [];

    const servicesSupportedList = servicesSupportedArray?.filter(v => v).map((serviceSupported, index) => {
        return (
            <ListItem  sublist key={index} >
                <ParagraphXSmall marginBottom={0} marginTop={0} >{BacnetServicesSupported[index]}</ParagraphXSmall>
            </ListItem>
        );
    });

    return (
        <>
        <ParagraphMedium>Supported Services</ParagraphMedium>
        <ul
            className={css({
                width: '375px',
                paddingLeft: 0,
                paddingRight: 0,
            })}
        >
            {servicesSupportedList}
        </ul>
        </>
    )

}

export default BacnetServicesSupportedList;
